<template>
  <DpplTooltip
    v-if="isInternal || isEvergreen"
    :tooltip-offset="12"
  >
    <template #activator="{ onMouseenter, onMouseleave }">
      <div
        class="badge"
        @mouseenter="onMouseenter"
        @mouseleave="onMouseleave"
      >
        {{ badgeData.title }}
      </div>
    </template>
    <template #tooltip-content>
      <p class="tooltip-content">
        {{ badgeData.tooltip }}
      </p>
    </template>
  </DpplTooltip>
</template>

<script setup>
import { computed } from 'vue';
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';

const props = defineProps({
  isInternal: { type: Boolean, default: false },
  isEvergreen: { type: Boolean, default: false },
});

const allBadgesData = {
  internal: {
    title: 'Internal',
    tooltip: 'This job post has not been published to any external job boards and is only available internally.',
  },
  evergreen: {
    title: 'Evergreen',
    tooltip: 'This job post is tied to an Evergreen requisition in Workday.',
  },
  'internal-evergreen': {
    title: 'Internal Evergreen',
    tooltip: 'This job post has not been published to any external job boards and is tied to an Evergreen requisition.',
  },
};

const badgeData = computed(() => {
  let key = '';
  if (props.isInternal) key = 'internal';
  if (props.isEvergreen) key = 'evergreen';
  if (props.isInternal && props.isEvergreen) key = 'internal-evergreen';

  if (!key) return {};

  return allBadgesData[key];
});
</script>

<style lang="less" scoped>
.badge {
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 8px;
  border: 1px solid @stroke-default;
  font-size: 12px;
  font-weight: 500;
  border-radius: 24px;
  color: @basic-yellow;
}

.tooltip-content {
  font-size: 13px;
  font-weight: 500;
  color: @text-darkest;
}
</style>
